import { useContext } from 'react'
import OrderContext from "../../contexts/orders/OrderContext";

const useOrders = () => useContext(OrderContext)

export default useOrders
